module.exports = __webpack_public_path__ + "static/img/academics-WBB-misc.a467d80.png";


//////////////////
// WEBPACK FOOTER
// ./static/academics-WBB-misc.png
// module id = YMuF
// module chunks = 1